import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { StatisticsByMonth } from '@classes/client-statistics/client-statistics-by-month';
import { ImageService } from '@services/image.service';
import { UiKpiService } from 'app/shared/kpi/core/services/ui-kpi.service';
import { Chart, Colors, registerables } from 'chart.js';
Chart.register(...registerables, Colors);

@Component({
  selector: 'app-crm-chart-by-month',
  styleUrls: ['./crm-chart-by-month.component.scss'],
  template: `
  <div>
    <canvas #chartCanvas style="height: 300px;"></canvas>
  </div>

  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>more_horiz</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="onDownloadClick()">
      <mat-icon>download</mat-icon>
      {{ 'global.button.download' | translate }}
    </button>
  </mat-menu>
  `
})
export class CRMChartByMonthComponent implements AfterViewInit, OnChanges, OnDestroy {
  @ViewChild('chartCanvas') chartCanvas: ElementRef | any;
  @Input() statisticsByMonth: StatisticsByMonth[] = [];

  private _chart: Chart;
  private _charBase64!: string;
  colors: string[] | any;

  constructor(
    private _uiSrv: UiKpiService,
    private _imageSrv: ImageService,
  ) {
    this.colors = this._uiSrv.getChartsColors();
  }

  public ngAfterViewInit(): void {
    this._initializeChart();
  }

  public ngOnChanges(): void {
    this._updateChart();
  }

  private _updateChart(): void {
    if (this._chart) {
      this._chart.data = this._generateChartData();
      this._chart.update();
    }
  }

  public ngOnDestroy(): void {
    if (this._chart)
      this._chart.destroy();
  }

  private _initializeChart(): void {
    this._chart = new Chart(this.chartCanvas.nativeElement, {
      type: 'bar',
      data: this._generateChartData(),
      options: {
        plugins: {
          title: {
            display: true,
            text: "Nombre de courses par mois"
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            stacked: true
          },
          x: {
            stacked: true,
          },
        },
        animation: {
          onComplete: () => {
            this._charBase64 = this._chart.toBase64Image();
          },
        },
      },
    });
  }

  private _generateChartData() {
    const labels = this.statisticsByMonth.map(stat => stat.month);
    const datasets = [
      this._generateNumberOfOrdersDataset(),
      this._generateNumberOfExtraOrdersDataset()
    ];

    return {
      labels,
      datasets
    }
  }

  private _generateNumberOfOrdersDataset() {
    const label = "Nombre de courses";
    const data = this.statisticsByMonth.map(stat => (stat.numberOfOrders - stat.numberOfExtraOrders));

    return this._buildDataset(label, data, this.colors[0]);
  }

  private _generateNumberOfExtraOrdersDataset() {
    const label = "Nombre de courses supplémentaires";
    const data = this.statisticsByMonth.map(stat => stat.numberOfExtraOrders);

    return this._buildDataset(label, data, this.colors[1]);
  }

  private _buildDataset(label: string, data: number[], backgroundColor: string) {
    return {
      label,
      data,
      backgroundColor,
      borderWidth: 1
    }
  }

  public onDownloadClick(): void {
    if (this._charBase64) {
      let chartName = 'chart-par-mois';

      this._imageSrv.downloadBase64File(
        this._charBase64,
        chartName
      );
    }
  }
}